import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { productsImages } from '../../assets/images'

function ProductsPageCta() {
  return (
    <AnimatedSection className="products-page-cta">
      <div className="container corp-container">
        <div className="products-page-cta__panel">
          <span className="products-page-cta__dots" aria-hidden="true" />
          <div className="row g-4 align-items-center">
            <div className="col-lg-7">
              <div className="products-page-cta__copy">
                <h2 className="products-page-cta__title">
                  Looking for Specific Metal Requirements?
                </h2>
                <p className="products-page-cta__text">
                  Share your grade, quantity and delivery needs — our team will respond with a
                  practical quote and supply plan.
                </p>
                <div className="products-page-cta__actions">
                  <Link className="products-page-cta__btn products-page-cta__btn--primary" to="/contact#quote-form">
                    Get A Quote
                    <FaArrowRight aria-hidden="true" />
                  </Link>
                  <Link className="products-page-cta__btn products-page-cta__btn--secondary" to="/contact#inquiry-form">
                    Send Inquiry
                    <FaArrowRight aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-5 d-none d-lg-block">
              <div className="products-page-cta__visual">
                <img src={productsImages.ctaCoils} alt="" loading="lazy" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ProductsPageCta
